<template>
    <div id="images" class="col-md-8 col-sm-12">
        <picture>
            <img class="img-responsive" :src="getActiveBikemodel().ImageLarge" :srcset="getActiveBikemodel().ImageMain + ' 768w,' + getActiveBikemodel().ImageLarge + ' 1199w,'" fetchpriority="high">
        </picture>
    </div>
    <div class="col-md-4 col-sm-12">
        <form>
            <div v-for="(question, questionIndex) in questions" :key="questionIndex" style="margin-bottom:30px;">
                <h4 style="border-bottom: 2px solid #f3f3f3">{{ question.Name }} <span><a href="javascript:void(0)" v-on:click="resetQuestion(question)">reset</a></span></h4>

                <label v-for="(spec, specIndex) in question.Values" :key="specIndex" style="display:block;font-weight:normal;">
                    <input type="radio" v-model="selected[question.Name]" :value="spec.Id" :disabled="SpecificationValueContainsBikeModels(spec) == false">
                    {{ spec.Name }}
                </label>
            </div>
        </form>

        <h3>Geselecteerde opties:</h3>
        <ul>
            <li v-for="(value, questionName) in selected" :key="questionName">
                {{ questionName }}: {{ findSpec(questionName, value).Name }}
            </li>
        </ul>

        <h3>Geselecteerde bike models:</h3>
        <ul>
            <li v-for="(item, index) in getBikeModelIds()" :key="index">
                {{item}}
            </li>
        </ul>
    </div>
</template>

<script>
    //import axios from 'axios';
    //import vueStore from '../../store/store.js';
    import cartMixin from '../../mixins/cart-mixin.js';
    import generalMixin from '../../mixins/general.js';

    export default {
        mixins: [cartMixin, generalMixin],
        data: function () {
            return {
                questions: window.combinationsData,
                bikemodels: window.bikemodelsData,
                selected: {}
            }
        },
        methods: {
            findSpec(questionName, selectedId) {
                const question = this.questions.find(q => q.Name === questionName);
                const spec = question ? question.Values.find(s => s.Id === selectedId) : null;
                return spec ? spec : null;
            },
            getBikeModelIds() {
                var result = [];
                if (Object.entries(this.selected).length > 0) {
                    for (var i = 0; i < this.questions.length; i++) {
                        var question = this.questions.find(q => q.Name === this.questions[i].Name);
                        var value = eval('this.selected.' + this.questions[i].Name);

                        if (value != undefined) {
                            var bikemodelIds = question.Values.find(x => x.Id === value).BikeModelIds;

                            if (result.length == 0) {
                                //no bikemodels yet, so add them all
                                for (var j = 0; j < bikemodelIds.length; j++) {
                                    result.push(bikemodelIds[j]);
                                }
                            } else {
                                //only keep the duplicates
                                var newResult = [];
                                for (var k = 0; k < result.length; k++) {
                                    if (bikemodelIds.find(x => x == result[k])) {
                                        newResult.push(result[k]);
                                    }
                                }
                                result = newResult;
                            }
                        }
                    }
                }
                return result;
            },
            SpecificationValueContainsBikeModels(spec) {
                var result = false;
                if (Object.entries(this.selected).length == 0) {
                    //no option selected. So all specs available
                    result = true;
                } else {
                    var bikemodelIds = this.getBikeModelIds();
                    result = spec.BikeModelIds.some(item => bikemodelIds.includes(item))
                }
                return result;
            },
            resetQuestion(question) {
                eval('delete this.selected.' + question.Name);
            },
            getActiveBikemodel() {
                if (this.getBikeModelIds().length > 0) {
                    return this.bikemodels.find(x => x.Id === this.getBikeModelIds()[0]);
                } else {
                    return this.bikemodels[0];
                }
            }
        },
        computed: {
        },
        beforeMount() {
        },
        created() {
            //this.interfaceTexts = JSON.parse(document.getElementById('vue-parameters').dataset.interfacetexts);
            //this.id = document.getElementById('vue-parameters-combinations').dataset.bikeserieid;
        }
    }
</script>
